/**
 * Definiert die v3s-connection Direktive <br/>
 * Die Direktive stellt eine Verbindung zwischen zwei {@link v3sWbtPlayerApp:exercise:connectable.directive_v3sConnectable} dar.
 * @class directive_v3sConnection
 * @memberOf v3sWbtPlayerApp:exercise:connectable
 * @param {string} v3s-from - id des ersten Elements
 * @param {string} v3s-to - id des zweiten Elements
 * @param {string} v3s-state - status der direktive wird übergeben, da ihr aussehen über attribute geändert wird
 * @param {string} v3s-angle - der Winkel in der die Connection gezeichnet werden soll
 * @param {number} v3s-width - die Breite der Direktive
 * @example
 * <v3s-connection v3s-from="cn01" v3s-to="cn02" v3s-state="useradded" v3s-tranform="rotate(90deg)" v3s-width="100"></v3s-connection>
 */
angular.module('v3sWbtPlayerApp').directive('v3sConnection', ['v3sConnectionElement', 'v3sExerciseService', 'v3sGeometricsService', '$tooltip', 'v3sI18nService', function (v3sConnectionElement, v3sExerciseService, v3sGeometricsService, $tooltip, v3sI18nService) {
    return {
        restrict: 'E',
        require: '^v3sConnections',
        scope: {
            v3sFrom: '@',
            v3sTo: '@',
            v3sState: '@',
            v3sAngle: '@',
            v3sWidth: '@'
        },
        link: function (scope, element, attrs, v3sConnectionsCtrl) {

            var connElement;
            var savedConnections = v3sConnectionsCtrl.loadSavedConnections();
            var foundConn;
            //If not already Loaded
            //Find out if this Connections is a saved one
            if (scope.v3sState == "loaded" && scope.v3sState != "updated" && typeof scope.v3sState != 'undefined') {
                angular.forEach(savedConnections, function (c, key) {
                    if ((c.userAnswer.to === scope.v3sTo && c.userAnswer.from === scope.v3sFrom) || (c.userAnswer.to === scope.v3sFrom && c.userAnswer.from === scope.v3sTo)) {
                        //ID setzen
                        c.id = key;
                        //Diese connection ist nun gezeichnet
                        if (scope.v3sState == "useradded") {
                            c.isDrawn = true;
                        }
                        foundConn = c;
                    }
                });
            }

            if (!!foundConn) {
                scope.v3sState = "loaded";
            }
            if (scope.v3sState == 'useradded') {//Falsche, vom User erstellte Connection
                connElement = new v3sConnectionElement("conn_" + scope.v3sFrom + scope.v3sTo, scope.v3sFrom, scope.v3sTo, false, element);
                connElement.setUserAnswer(true);
                connElement.setShowFeedback(showFeedback);
                v3sConnectionsCtrl.addConnectionElement(connElement);
            } else if (typeof scope.v3sState == 'undefined') {
                //Erste initalisierung
                connElement = new v3sConnectionElement("conn_" + scope.v3sFrom + scope.v3sTo, scope.v3sFrom, scope.v3sTo, true, element);
                connElement.setShowFeedback(showFeedback);
                v3sConnectionsCtrl.addConnectionElement(connElement);
            } else if (scope.v3sState == 'loaded') {
                connElement = new v3sConnectionElement(foundConn.id, scope.v3sFrom, scope.v3sTo, foundConn.isCorrectAnswer, element);
                connElement.status = foundConn.status;
                connElement.userAnswer = foundConn.userAnswer;
                connElement.isDrawn = foundConn.isDrawn;
                connElement.checkAnswer();
                connElement.save();
                //v3sExerciseService.checkExercise(connElement);
                v3sConnectionsCtrl.addConnectionElement(connElement);
                connElement.setShowFeedback(showFeedback);
            }

            if (scope.v3sState == 'useradded' || typeof scope.v3sState == 'undefined' || scope.v3sState == 'loaded') {
                element.bind('click', deleteConnection);
            }

            //Wenn v3sTransform gesetzt ist, wird dieser im css gesetzt
            if (!!scope.v3sAngle) {
                TweenLite.set(element, {
                    rotation: scope.v3sAngle + '_short'
                });
            }


            //Optisches "Löschen" des Elements bei klick
            function deleteConnection() {
                if (!connElement.completed && !element.hasClass('correct')) {
                    element.css('width', 0);
                    connElement.setUserAnswer(false);
                }
            }

            //Attribute löschen, damit nicht betrogen werden kann
            element.removeAttr('v3s-from').removeAttr('v3s-to');

            //Feedback setzen
            function showFeedback() {
                if (!connElement.isFeedbackVisible()) return;
                if (!!tooltip) {
                    tooltip.hide();
                }
                var self = this;

                //Wenn das Element sichtbar ist
                if (self.isDrawn) {
                    if (self.status == self.STATUS.CORRECT) {
                        /**
                         * Da die gespeicherten Elemente erst geladen werden
                         * wenn für die korrekten connectionElemente bereits die showfeeback-Funktion
                         * ausgeführt wurde,
                         * werden korrekt gegebenen Antworten erst im nachhinein gezeichnet.
                         * Darum muss die klasse corretNotFound ggf entfernt werden
                         */

                        element.removeClass("correctNotFound");
                        element.addClass('correct');
                    } else {
                        element.addClass('wrong');
                    }
                } else {
                    if (!self.isCorrectAnswer) return;
                    //Das Element muss gezeichnet werden
                    //-> Sammeln der Koordinaten
                    var fromEl = angular.element(document.getElementById(self.from));
                    var toEl = angular.element(document.getElementById(self.to));
                    var fromCenter = v3sGeometricsService.getCenterPoint(fromEl);
                    var toCenter = v3sGeometricsService.getCenterPoint(toEl);

                    var bestConnection = v3sGeometricsService.findBestConnection(fromEl, toEl);
                    var deg = v3sGeometricsService.calculateAngle(bestConnection.x1, bestConnection.y1, bestConnection.x2, bestConnection.y2);
                    var w = v3sGeometricsService.calculateLength(bestConnection.x1, bestConnection.y1, bestConnection.x2, bestConnection.y2) + "px";

                    //Setzen des StartPunkts
                    TweenLite.set(element, {
                        left: bestConnection.x1,
                        top: bestConnection.y1,
                        rotation: deg + '_short'
                    })

                    //Animation der Linie
                    TweenLite.to(element, 0.5, {
                        width: w
                    });
                    element.addClass('correctNotFound');
                }

                //FOD = nur der Status
                var status = connElement.getStatus();
                var msg = v3sI18nService.getText([
                    "exercises.fod.cn." + status.name,
                    "exercises.fod.general." + status.name
                ]);
                var tooltip = $tooltip(element, { title: msg });
            }
        }
    };
}]);
